import React from 'react'
import ClassNames from 'classnames'
import { NewBlockStyle } from './styled'
import { CONTENTS } from '../../themes'
import { HighLight } from '../../helpers/highLight'

/**
 * NewBlock description
 * - ...
 */

export class NewBlock extends React.PureComponent {
  render() {
    const {
      className,
      title,
      dateTime,
      key,
      id,
      metaName,
      srcImage,
      description,
      onClick,
      tagHighlight,
    } = this.props
    const regex = /(<([^>]+)>)/gi
    const result = description.replace(regex, '')
    const desc = result.replace(/\&nbsp;/g, '')
    return (
      <NewBlockStyle
        className={ClassNames('card-new', className)}
        key={key}
        id={id}
        onClick={onClick}
      >
        <div className="card-body">
          <h5 className="card-title">
            {/* {title} */}
            <HighLight
              highlightClassName="taxt-highlight"
              textToHighlight={title}
              searchWords={tagHighlight}
            />
          </h5>
          <div className="card-meta">
            <span>{metaName}</span>
            <div className="time">{dateTime}</div>
          </div>
          <p>
            <HighLight
              highlightClassName="highlight"
              textToHighlight={desc}
              searchWords={tagHighlight}
            />
          </p>
          {/* <div dangerouslySetInnerHTML={{ __html: description }}>
            {description}
          </div> */}
        </div>
        {srcImage && (
          <div
            className="center-cropped"
            style={{ backgroundImage: `url(${srcImage})` }}
          >
            <img
              src={srcImage}
              alt="image"
              className="image"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = CONTENTS['cover.png']
              }}
            />
          </div>
        )}
      </NewBlockStyle>
    )
  }
}
